<template>
  <div>
    <div class="cctdb">
      <router-link :to="parentRoute" class="just-a-link">
        <span>{{ parentName }}</span>
      </router-link> 
      <span class="arrow">&gt;</span> 
      <span v-if="childName">{{ childName }}</span>
    </div>
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */

/* API */

export default defineComponent({
  name: 'CardCanvasTwoDeepBreadcrumb',

  props: {
    parentRoute: {
      type: Object,
      required: true,
    },
    parentName: {
      type: String,
      required: true,
    },
    childName: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      RouteAssistant,
    }
  },
})
</script>

<style lang="scss">
.cctdb {
  margin-bottom: 30px;
  @include lettering--p-sm;

  > span {
    padding-left: 8px;

    &.arrow {
      color: var(--color-text-third);
    }
  }
}
</style>
